<template>
  <div class="dashboard">
    <v-container class="my-5">
      <v-row justify="center">
        <v-col cols="4">
          <v-card>
            <v-card-text>
              <v-text-field
                v-model="search"
                label="Search"
                single-line
                hide-details
                @keyup.enter="doSearch"
                append-icon="mdi-magnify"
                @click:append="doSearch"
              ></v-text-field>
              <v-radio-group v-model="radioGroup">
                <v-radio v-for="searchOption in availableSearchChoises" :key="searchOption.value" :label="searchOption.text" :value="searchOption.value"></v-radio>
              </v-radio-group>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <CustomersTable :propHeaders="customersHeaders" />
        </v-col>

        <v-col>
          <ItemsTable :propHeaders="itemsHeaders" :propItems="$store.state.items" />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import ItemsTable from '@/components/ItemsTable'
import CustomersTable from '@/components/CustomersTable'

export default {
  name: 'Dashboard',

  components: {
    ItemsTable,
    CustomersTable
  },

  created () {
    this.$store.dispatch('setCustomers', [])
    this.$store.dispatch('setItems', [])
  },

  data: () => ({
    search: '',
    radioGroup: 1,
    availableSearchChoises: [
      { text: 'Items', value: 1 },
      { text: 'Customers', value: 2 }
    ],
    itemsHeaders: [
      { text: 'Serial Number', value: 'serialNumber' },
      { text: 'Casing ID', value: 'casingId' },
      { text: 'IMSI', value: 'imsi' },
      { text: 'ICCID', value: 'iccid' }
    ],
    customersHeaders: [
      { text: 'Name', value: 'name' },
      { text: 'Email', value: 'email' }
    ]
  }),

  methods: {
    doSearch () {
      if (this.radioGroup === 1) {
        // Search items
        this.$store.dispatch('getItemsByFilter', this.search)
      } else if (this.radioGroup === 2) {
        // Search customers
        this.$store.dispatch('getCustomersByFilter', this.search)
      }
    }
  }
}
</script>
